var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollHistoricReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4819 36V47.25M40.9819 47.25L32.0913 39.8411C30.4515 38.4746 29.6316 37.7914 28.7164 37.5303C27.9095 37.3001 27.0543 37.3001 26.2474 37.5303C25.3322 37.7914 24.5124 38.4746 22.8726 39.8411L13.9819 47.25M18.4819 24.75V27M27.4819 20.25V27M36.4819 15.75V27M49.9819 6.75H4.98193M7.23193 6.75H47.7319V25.2C47.7319 28.9804 47.7319 30.8705 46.9962 32.3144C46.3491 33.5845 45.3165 34.6171 44.0464 35.2643C42.6025 36 40.7123 36 36.9319 36H18.0319C14.2516 36 12.3614 36 10.9175 35.2643C9.6474 34.6171 8.61478 33.5845 7.96764 32.3144C7.23193 30.8705 7.23193 28.9804 7.23193 25.2V6.75Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollHistoricReports);
export default __webpack_public_path__ + "static/media/PayrollHistoricReports.4673abd8b40e7f5b1c3ebccc8ea9f0ab.svg";
export { ForwardRef as ReactComponent };